import React from 'react';
import { reduxForm, Field } from 'redux-form';

import { SelectInput } from '../SelectInput';
import { TagsService} from '../../services';

class AlertDashboardTagsForm extends React.Component {
  constructor(props) {
    super(props);

    // TODO handle pre-selected tags
    // TODO handle save

    this.state = {
      tagOptions: null
    };
  }

  componentDidMount() {
    TagsService.listAll().then((response) => {
      this.setState({ tagOptions: response.tags.filter(tag => tag.tagType && (tag.tagType.token !== 'checklist-passive-device' && tag.tagType.token !== 'checklist-type'))
                                               .map(tag => ({label: tag.name, value: tag.id})) });
    }).catch((error) => {
      console.error(error);
      this.setState({ errorMessage: 'Could not load tags for viewing.' });
    });
  }

  render() {
    if (this.state.tagOptions) {
      return (
        <form className="tag-edit-form time-select fade-in" style={{zIndex: 900}}>
          <span className="time-select-label">Tags</span>
          <Field
            name="roles"
            options={this.state.tagOptions}
            component={SelectInput}
            isMulti
            isOptionDisabled={(option) => this.props.isDisabled}
            onChange={this.props.onSelection}
          />
        </form>
      );
    } else {
      return (
        <div className="loader">Loading...</div>
      );
    }
  }
}

export default reduxForm({ form: 'AlertDashboardTagsForm' })(AlertDashboardTagsForm);
